import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {  Nav } from "react-bootstrap";
import { connect } from "react-redux";
import Books from "../../Components/Books/Books";
import * as actions from "../../Store/Actions/index";
import "./BestSeller.css";
import Axios from '../../axios-instance';
import { withRouter } from "react-router-dom";
import Spinner from '../../Components/UI/Spinner/Spinner'
class Bestseller extends Component {
  state = {
    BestSellerBooks: [],
    activeBook :[]
  };
  componentWillMount() {
    Axios.get("get/vk/books/home").then((response) => {
      this.setState({
        BestSellerBooks : response.data,
        activeBook : response.data.class_books.data
      })
    })
  }
  goToCatalogue = () => {
    this.props.history.push("/catalogue");
  };
  bookCategory = (type) => {
    if (type === "text") {
      this.setState({
        activeBook: this.state.BestSellerBooks.class_books.data
      });
    }
    if (type === "college") {
      console.log(this.state.BestSellerBooks)
      this.setState({
        activeBook: this.state.BestSellerBooks.college_books.data
      });
    }
    if (type === "sample") {
      this.setState({
        activeBook: this.state.BestSellerBooks.xamidea.data
      });
    }
  };
  render() {
    return (
      <Container>
        <Row className = "bestSellerRow">
          <Col xs={12} sm={12}  md={12} lg={3}>
            <h3 className="heading">BESTSELLER</h3>
            <div className="listCategory justify-content-center">
              <Nav variant="pills" defaultActiveKey="1">
                <Nav.Item>
                  <Nav.Link
                    id="nav"
                    eventKey="1"
                    onClick={() => this.bookCategory("text")}
                  >
                    Textbooks
                  </Nav.Link>
                  <Nav.Link
                    id="nav"
                    eventKey="2"
                    onClick={() => this.bookCategory("college")}
                  >
                    College Books
                  </Nav.Link>
                  <Nav.Link
                    id="nav"
                    eventKey="3"
                    onClick={() => this.bookCategory("sample")}
                  >
                    Sample Papers
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
          </Col>
          <Col  xs={12} sm={12} md={12} lg={9}>
            <Row >
              {
                this.state.activeBook.length > 0 ?
                (
                  this.state.activeBook.map((book,index) => {
                    return (
                      <Col className = "md-book " key = {index} xs={6} sm={6} md={3} lg={3}>
                        <Books content={book} />
                      </Col>
                    );
                  })
                )
                :
                <Spinner />
              }
            </Row>
          </Col>
        </Row>
        <Row>
          <Col sm={11} className="otherBook">
            <button className="otherBookButton" onClick={this.goToCatalogue}>
              VIEW OTHERS
              <i className="icon dripicons-arrow-thin-right"></i>{" "}
            </button>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    books: state.book.books,
    textbook: state.book.textbook,
    collegeBooks: state.book.collegeBooks,
    samplePapers: state.book.samplePapers,
    loading: state.book.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBooks: () => dispatch(actions.fetchBooks()),
    GetBookByType: () => dispatch(actions.GetBookByType()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Bestseller));
